import React, { Component } from 'react';

/**
* WebsiteEditorRedirect component
* @author   Milan Stanojevic
*/
class WebsiteEditorRedirect extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }

        const url = this.props.uData?.clinicGroups?.[selectedGroupIdx]?.websiteEditorUrl;

        if (url)
            window?.open?.(url, '_blank');


        setTimeout(() => {
            this.props[0].history.goBack();
        }, 200);
    }


    render() {

        return (
            <div>
            </div>
        );
    }
}

export default WebsiteEditorRedirect;